<div class="text-14-400-157 input-container">
    <span (click)="mySelector.open()" class="text-c2 me-2 d-flex align-items-start">
        <span *ngIf="showLabel && label">{{label | translate}}:</span>
        <img *ngIf="selectedItem?.image && !this.label" class="pe-2"  [src]="selectedItem?.image" alt="">
    </span>
    <mat-select #mySelector [(value)]="selectedId" (selectionChange)="onChange(selectedId)">
    <mat-option *ngFor="let option of optionList ;let i =index;" [value]="option.id">
        <img class="pe-2" *ngIf="option['image']" [src]="option['image']" alt="">
        {{ option['name'] | translate }}
    </mat-option>
    </mat-select>
</div>
